define(['jQuery',
    'library/fcse-request/request',
    'library/fcse-util/url'
],
    function($, Request, Url) {
        
        var CountButton = function (element, options) {
            this.element = $(element);
            this.count = 1;
            this.options = options;
            this.request = new Request();
            this.link = this.element;
            this.linkText = this.element;
            this.labels = {
                singularPattern: this.element.data("singular-pattern"),
                pluralPattern: this.element.data("plural-pattern")
            };
            this._registerClickHandler();
        };
        
        CountButton.prototype = {
            /**
             * Register clickhandler to prevent click when 0 results
             * @returns {undefined}
             */
            _registerClickHandler : function() {
                var self = this;
                this.link.click(function(event){
                    if (self.count == 0){
                        event.preventDefault();
                    }
                });
            },
            setCountText: function (count) {
                var text;
                this.count = count;
                if (count === 1) {
                    text = this.labels.singularPattern.replace("{1}", count);
                }
                else {
                    text = this.labels.pluralPattern.replace("{1}", count);
                }
                this.linkText.removeClass("is-loading");
                this.linkText.text(text);
            },
            updateUrl: function (params) {
                var routeParams = { };
                var queryParams = params;
            
                // Change the link on button.
                var url = new Url(this.link.attr("href"));
                url.query = queryParams;
                url.hash = { };
                this.link.attr("href", url.toString());
                this.toggleEnabled();
            },
            setLoading: function () {
                this.linkText.text("");
                this.linkText.addClass("is-loading");
            },
            toggleEnabled: function () {
                if (this.count > 0){
                    this.element.removeClass("is-disabled");
                } else {
                    this.element.addClass("is-disabled");
                }
            }
        };
        
        return CountButton;
    }
);


//////////////////
// WEBPACK FOOTER
// ./~/fcse-countbutton/countButton.js
// module id = 232
// module chunks = 7 8 9 10 11 12 13 14